import React from "react";
import {
  Box,
  Button,
  Chip,
  Container,
  Link as MuiLink,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ImageIcon from "@mui/icons-material/Image";
import AddIcon from "@mui/icons-material/Add";
import LaunchIcon from "@mui/icons-material/Launch";
import { BodyText } from "../../../widgets/TemplatePreview";
import { renderHeader } from "./ShowInteractiveButtons";

const ShowInteractiveCtaUrl = ({ data, onOpen, preview = false }) => {
  /* ---------------- MAIN RENDER ------------------------------------ */
  return (
    <Container maxWidth="md">
      <Paper variant="outlined" elevation={0} sx={{ p: 2 }}>
        {/* Trigger chips */}
        {!preview && (
          <Stack direction="row" spacing={1} flexWrap="wrap" my={1}>
            {(data.triggerText || []).map((item) => (
              <Chip key={item} variant="outlined" label={item} clickable />
            ))}
          </Stack>
        )}
        {renderHeader(data)}
        <BodyText sx={{ my: 1 }}>{data.body}</BodyText>
        <Button
          variant="contained"
          fullWidth
          endIcon={<LaunchIcon />}
          href={data.url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ textTransform: "none", my: 1 }}
        >
          {data.label}
        </Button>
        {data.footer && (
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            mt={0.5}
          >
            {data.footer}
          </Typography>
        )}
        {!preview && (
          <Stack direction="row" justifyContent="end" mt={2}>
            <Button
              onClick={() => onOpen?.()}
              startIcon={<AddIcon />}
              variant="outlined"
              size="small"
            >
              Add trigger
            </Button>
          </Stack>
        )}
      </Paper>
    </Container>
  );
};

export default ShowInteractiveCtaUrl;
